import React from "react";
import LocalShippingOutlinedIcon from "@material-ui/icons/LocalShippingOutlined";

import AccordionCard from "../../../../../../components/common/PL/AccordionCard/AccordionCard";
import TransportContentDriverForm from "./TransportContentDriverForm";
import VehicleContentForm from "../../AccessVehicleForm/VehicleContentForm/VehicleContentForm";
import { RegistrationMode } from "../../../registroIngresoNavigation";

import EmpresaSearch from "./EmpresaSearch";
import NuevaEmpresaModal from "./NuevaEmpresaModal";
import { TransportAuthorizationFlow } from "./useTransportAuthorizationFlow";

import "./TransportContentForm.css";
import "./TransportContentForm.transport.css";

type TransportContentFormProps = {
  disabled?: boolean;
  mode?: RegistrationMode;
  /** Vehículos ya registrados del chofer, para prefillear y buscar por patente. */
  vehicles?: any[];
  flow: TransportAuthorizationFlow;
};

const TransportContentForm: React.FC<TransportContentFormProps> = ({
  disabled = false,
  mode,
  vehicles = [],
  flow,
}) => {
  return (
    <div className="transportFormContent">
      <div style={{ marginBottom: "24px" }}>
        <AccordionCard
          id="transport-company-section"
          titleKey="Empresa Transportista"
          icon={<LocalShippingOutlinedIcon />}
          expanded={true}
        >
          <div className="transportEmpresaSection">
            <EmpresaSearch
              searchValue={flow.search}
              onSearchChange={flow.setSearch}
              selectedEmpresa={flow.selectedEmpresa}
              onSelect={flow.handleSelectEmpresa}
              onClear={flow.handleClearEmpresa}
              options={flow.companies}
              getLabel={(company) => company.name}
              disabled={disabled}
              isLarge={true}
              filterLocally={false}
              onAddNew={(searchText) =>
                flow.setNuevaEmpresaModal({ open: true, prefillNombre: searchText })
              }
            />
          </div>
        </AccordionCard>
      </div>

      <TransportContentDriverForm disabled={disabled} mode={mode} />
      <VehicleContentForm isAccordion={true} vehicles={vehicles} disabled={disabled} mode={mode} />

      <NuevaEmpresaModal
        open={flow.nuevaEmpresaModal.open}
        prefillNombre={flow.nuevaEmpresaModal.prefillNombre}
        onClose={() => flow.setNuevaEmpresaModal({ open: false, prefillNombre: "" })}
        onSubmit={flow.handleCrearEmpresa}
      />
    </div>
  );
};

export default TransportContentForm;
